// LinkedIn initialization

Jelly.Connections.LinkedIn_Login = function (Parameters) { 

	var Start_LinkedIn_Login = function () {
		IN.User.authorize(Continue_LinkedIn_Login);
	}

	var Continue_LinkedIn_Login = function (Parameters) {
		IN.API.Profile("me")
			.fields("id", "first-name", "last-name", "email-address", "public-profile-url", "picture-urls::(original)")
			.result(
				Save_LinkedIn_Data
      ).error(function (data) {

      	// Get error context
      	if (Parameters["Error_Namespace"]) {
      		var Error_Namespace = Parameters["Error_Namespace"];
      	}
      	else {
      		var Error_Namespace = Parameters["Namespace"];
      	}

      	// Display generic error
      	Jelly.Actions.Show_Result({
					Namespace: Error_Namespace,
					Content: "Sorry! We were unable to log you in through LinkedIn."
				});
      });
	}

	var Save_LinkedIn_Data = function (Response) {
		var Profile = Response.values[0];
		var ID = Profile["id"];
		var URL = Profile["publicProfileUrl"];
		var Email = Profile["emailAddress"];
		var First_Name = Profile["firstName"];
		var Last_Name = Profile["lastName"];
		var Name = First_Name + " " + Last_Name;
		var Path_To_Profile_Photo = Profile["pictureUrls"].values[0];
		var Namespace = Parameters["Namespace"];

		// Save input values
		Jelly.Actions.Set_Input_Value(
				{
					Namespace: Namespace,
					Alias: "Account_Platform",
					Value: "LinkedIn"
				}
			);
		Jelly.Actions.Set_Input_Value(
				{
					Namespace: Namespace,
					Alias: "Account_ID",
					Value: ID
				}
			);
		Jelly.Actions.Set_Input_Value(
				{
					Namespace: Namespace,
					Alias: "Account_URL",
					Value: URL
				}
			);
			
		Jelly.Actions.Set_Input_Value(
				{
					Namespace: Namespace,
					Alias: "Email_Address",
					Value: Email
				}
			);
			
		Jelly.Actions.Set_Input_Value(
			{
				Namespace: Namespace,
				Alias: "Person_Name",
				Value: Name
			}
		);

		Jelly.Actions.Set_Input_Value(
				{
					Namespace: Namespace,
					Alias: "First_Name",
					Value: First_Name
				}
			);
			
		Jelly.Actions.Set_Input_Value(
				{
					Namespace: Namespace,
					Alias: "Last_Name",
					Value: Last_Name
				}
			);
			
		Jelly.Actions.Set_Input_Value(
				{
					Namespace: Namespace,
					Alias: "Picture_URL",
					Value: Path_To_Profile_Photo
				}
			);
		
		// Execute action.
		Jelly.Handlers.Call_Handler_For_Target({'Event': 'Execute', 'Target': document.getElementById(Namespace)});
	}
	
	Start_LinkedIn_Login();
} 